export enum DroppoErrors {
  NO_CELL_ERROR = 'noCell',
  USER_NOT_VERIFIED_ERROR = 'userNotVerified',
  USER_CREATED_BY_PHONE_ERROR = 'userCreatedByPhone',
  DAILY_VALIDATION_SMS_LIMIT_REACH = 'dailyValidationSmsLimitReach',
  SYSTEM_MINUTE_VALIDATION_SMS_LIMIT_REACH = 'allUserMinuteValidationSmsLimitReach',
}

